export const TYPES = {
    SELECT_ALL_INCOME_SUCCESS: "income_detail/SELECT_ALL_INCOME_SUCCESS",
  };
  